export default "__VITE_ASSET__C8jk7DA6__"